import React, { useEffect, useState } from "react";
import styles from "./style.module.css";
// import Header from "../../partials/EternalHeader";
import Header from "../../partials/ExternalHeader";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import yeslocker from "../../../images/new images/longyes.png";
import yeslocker2 from "../../../images/new images/longyes4.png";
import nolocker from "../../../images/new images/longno.png";
import nolocker2 from "../../../images/new images/longno2.png";
import shortyes from "../../../images/new images/shortyes.png";
import shortno from "../../../images/new images/shortno.png";
import lock from "../../../images/Lock.svg";
import Swal from "sweetalert2";
import mockup from "../../../images/new images/gray.png";
import mockup2 from "../../../images/new images/gray2.png";
import "sweetalert2/dist/sweetalert2.min.css";
import Modal from "react-modal";
// import { toast } from "react-toastify";
import { notification } from "antd";
const url = process.env.REACT_APP_APP_BACK_URL;
const DashboardScr = () => {
  const isAuthenticated = useSelector((state) => state.user);
  let { slug } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [locker_display, setlocker_display] = useState(true);
  const [isDisplay, setIsDisplay] = useState(false);
  const [isLockerOpen, setIsLockerOpen] = useState(false);
  const [selectedLockerNumber, setselectedLockerNumber] = useState("");
  const [getLocker, setLocker] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLocker, setselectedLocker] = useState("");

  useEffect(() => {
    siteLockers();
  }, []);

  // get all site
  const siteLockers = async () => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      const response = await fetch(`${url}/api/sites/lockers/${slug}`, {
        mode: "cors",
        method: "GET",
        headers: headers,
      });
      const json = await response.json();

      if (json.success) {
        setselectedLocker("");
        setIsDisplay(true);
        setLocker(json.lockers);
        console.log(json.lockers[0]._id);
      } else {
        notification.error({
          message: "Error",
          description: json.error,
          duration: 3,
        });
        // toast.error(json.error);
      }
    } catch (error) {
      console.error(error);
    }
  };
  // open locker
  const openLocker = async (id) => {
    let state = "2";
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    setIsLockerOpen(true);
    setIsLoading(true);
    const response = await fetch(`${url}/api/sites/relay/state/update`, {
      mode: "cors",
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        id: id,
        state: state,
      }),
    });

    setIsLockerOpen(false);
    const json = await response.json();
    if (json.success) {
      // toast.success(json.message);
      notification.success({
        message: "Success",
        description: json.message,
        duration: 3,
      });
    } else {
      notification.error({
        message: "Error",
        description: json.error,
        duration: 3,
      });
      // toast.error(json.error);
    }
    setIsLoading(false);
    siteLockers();
  };
  //   modal functions
  const openModal = (id) => {
    setIsModalOpen(true);
    setselectedLocker(id);
  };
  // set id
  const displayOpen = async (id, relay) => {
    const result = await Swal.fire({
      title: `Do you want to open locker number ${
        relay < 9 ? "0" + relay : relay
      }?`,
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes!",
      cancelButtonText: "No",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      setselectedLocker(id);
      // if (selectedLocker === id) {
      openLocker(id);
      // }
    }
  };

  const displayOpen1 = async (id, relay) => {
    const result = await Swal.fire({
      title: `Do you want to open locker number ${
        relay < 9 ? "0" + relay : relay
      }?`,
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes!",
      cancelButtonText: "No",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      setselectedLocker(id);
      // if (selectedLocker === id) {
      openModal(id);
      // }
    }
  };

  const closeModal = () => {
    setselectedLocker("");
    setIsModalOpen(false);
  };
  // return to available locker
  const returnLocker = async () => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    setIsLoading(true);
    const response = await fetch(
      `${url}/api/sites/changeToAvailable/${selectedLocker}`,
      {
        mode: "cors",
        method: "GET",
        headers: headers,
      }
    );

    const json = await response.json();
    if (json.success) {
      // toast.success(json.message);
      notification.success({
        message: "Success",
        description: json.message,
        duration: 3,
      });
      siteLockers();
      setIsLoading(false);
      setIsModalOpen(false);
    } else {
      notification.error({
        message: "Error",
        description: json.error,
        duration: 3,
      });
      // toast.error(json.error);
    }
  };
  return (
    <div className={styles.heading}>
      <div className="body-wrap">
        <div className="container-fluid px-0">
          <Header />
          <div className="container-fluid text-center p-2">
            <div className="d-flex justify-content-center align-items-center mt-5 ">
              <div className=" d-flex flex-row gap-md-4">
                <div className=" d-flex flex-column gap-md-3 justify-content-end">
                  {getLocker[0] && (
                    <>
                      <div
                        className={`  ${
                          isLoading && selectedLocker !== getLocker[0]._id
                            ? "loading-disabled"
                            : ""
                        }`}
                      >
                        <div className="lockers">
                          <span className="dot1">{1}</span>
                          {getLocker[0].status === "available" ? (
                            <>
                              {selectedLocker === getLocker[0]._id && (
                                <div className="locker-button-text2">OPEN</div>
                              )}
                              <img
                                src={shortyes}
                                alt="yes"
                                onClick={() =>
                                  displayOpen(getLocker[0]._id, "1")
                                }
                              />
                            </>
                          ) : (
                            <>
                              {selectedLocker === getLocker[0]._id && (
                                <div className="locker-button-text2">CLOSE</div>
                              )}
                              <img
                                src={shortno}
                                onClick={() =>
                                  displayOpen1(getLocker[0]._id, "1")
                                }
                                alt="yes"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  {getLocker[1] && (
                    <>
                      <div
                        className={`  ${
                          isLoading && selectedLocker !== getLocker[1]._id
                            ? "loading-disabled"
                            : ""
                        }`}
                      >
                        <div className="lockers">
                          <span className="dot1">{2}</span>
                          {getLocker[1].status === "available" ? (
                            <>
                              {selectedLocker === getLocker[1]._id && (
                                <div className="locker-button-text2">OPEN</div>
                              )}
                              <img
                                src={shortyes}
                                alt="yes"
                                onClick={() =>
                                  displayOpen(getLocker[1]._id, "2")
                                }
                              />
                            </>
                          ) : (
                            <>
                              {selectedLocker === getLocker[1]._id && (
                                <div className="locker-button-text2">CLOSE</div>
                              )}
                              <img
                                src={shortno}
                                onClick={() =>
                                  displayOpen1(getLocker[1]._id, "2")
                                }
                                alt="yes"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  {getLocker[2] && (
                    <>
                      <div
                        className={`${
                          isLoading && selectedLocker !== getLocker[2]._id
                            ? "loading-disabled"
                            : ""
                        }`}
                      >
                        <div className="lockers">
                          <span className="dot1">{3}</span>
                          {getLocker[2].status === "available" ? (
                            <>
                              {selectedLocker === getLocker[2]._id && (
                                <div className="locker-button-text">OPEN</div>
                              )}
                              <img
                                src={shortyes}
                                alt="yes"
                                onClick={() =>
                                  displayOpen(getLocker[2]._id, "3")
                                }
                              />
                            </>
                          ) : (
                            <>
                              {selectedLocker === getLocker[2]._id && (
                                <div className="locker-button-text">CLOSE</div>
                              )}
                              <img
                                src={shortno}
                                onClick={() =>
                                  displayOpen1(getLocker[2]._id, "3")
                                }
                                alt="yes"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className=" d-flex flex-column gap-md-3 justify-content-end">
                  {getLocker[3] && (
                    <>
                      <div
                        className={` ${
                          isLoading && selectedLocker !== getLocker[3]._id
                            ? "loading-disabled"
                            : ""
                        }`}
                      >
                        <div
                          // style={{
                          //   height: 170,
                          //   width: 130,
                          // }}
                          className="lockers "
                        >
                          <span className="dot2">{4}</span>
                          {getLocker[3].status === "available" ? (
                            <>
                              {selectedLocker === getLocker[3]._id && (
                                <div className="locker-button-text2">OPEN</div>
                              )}
                              <img
                                src={yeslocker2}
                                // width={"100%"}
                                // height={"100%"}
                                alt="yes"
                                onClick={() =>
                                  displayOpen(getLocker[3]._id, "4")
                                }
                              />
                            </>
                          ) : (
                            <>
                              {selectedLocker === getLocker[3]._id && (
                                <div className="locker-button-text2">CLOSE</div>
                              )}
                              <img
                                src={nolocker2}
                                // width={"100%"}
                                // height={"100%"}
                                onClick={() =>
                                  displayOpen1(getLocker[3]._id, "4")
                                }
                                alt="yes"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  {getLocker[4] && (
                    <>
                      <div
                        className={` ${
                          isLoading && selectedLocker !== getLocker[4]._id
                            ? "loading-disabled"
                            : ""
                        }`}
                      >
                        <div
                          // style={{
                          //   height: 180,
                          //   width: 130,
                          // }}
                          className="lockers"
                        >
                          <span className="dot2">{5}</span>
                          {getLocker[4].status === "available" ? (
                            <>
                              {selectedLocker === getLocker[4]._id && (
                                <div className="locker-button-text2">OPEN</div>
                              )}
                              <img
                                src={yeslocker2}
                                // width={"100%"}
                                // height={"100%"}
                                alt="yes"
                                onClick={() =>
                                  displayOpen(getLocker[4]._id, "5")
                                }
                              />
                            </>
                          ) : (
                            <>
                              {selectedLocker === getLocker[4]._id && (
                                <div className="locker-button-text2">CLOSE</div>
                              )}
                              <img
                                src={nolocker2}
                                // width={"100%"}
                                // height={"100%"}
                                onClick={() =>
                                  displayOpen1(getLocker[4]._id, "5")
                                }
                                alt="yes"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className=" d-flex flex-column  gap-md-3 justify-content-end">
                  <div className="">
                    <div className="lockers">
                      <img src={mockup2} alt="yes" />
                    </div>
                  </div>

                  {getLocker[5] && (
                    <>
                      <div
                        className={` ${
                          isLoading && selectedLocker !== getLocker[5]._id
                            ? "loading-disabled"
                            : ""
                        }`}
                      >
                        <div className="lockers">
                          <span className="dot1">{6}</span>
                          {getLocker[5].status === "available" ? (
                            <>
                              {selectedLocker === getLocker[5]._id && (
                                <div className="locker-button-text2">OPEN</div>
                              )}
                              <img
                                src={shortyes}
                                alt="yes"
                                onClick={() =>
                                  displayOpen(getLocker[5]._id, "6")
                                }
                              />
                            </>
                          ) : (
                            <>
                              {selectedLocker === getLocker[5]._id && (
                                <div className="locker-button-text2">CLOSE</div>
                              )}
                              <img
                                src={shortno}
                                onClick={() =>
                                  displayOpen1(getLocker[5]._id, "6")
                                }
                                alt="yes"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className=" d-flex flex-column gap-md-3 justify-content-end">
                  {getLocker[6] && (
                    <>
                      <div
                        className={`${
                          isLoading && selectedLocker !== getLocker[6]._id
                            ? "loading-disabled"
                            : ""
                        }`}
                      >
                        <div className="lockers">
                          <span className="dot">{7}</span>
                          {getLocker[6].status === "available" ? (
                            <>
                              {selectedLocker === getLocker[6]._id && (
                                <div className="locker-button-text">OPEN</div>
                              )}
                              <img
                                src={yeslocker}
                                alt="yes"
                                onClick={() =>
                                  displayOpen(getLocker[6]._id, "7")
                                }
                              />
                            </>
                          ) : (
                            <>
                              {selectedLocker === getLocker[6]._id && (
                                <div className="locker-button-text">CLOSE</div>
                              )}
                              <img
                                src={nolocker}
                                onClick={() =>
                                  displayOpen1(getLocker[6]._id, "7")
                                }
                                alt="yes"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className=" d-flex flex-column gap-md-3 justify-content-end">
                  {getLocker[7] && (
                    <>
                      <div
                        className={`${
                          isLoading && selectedLocker !== getLocker[7]._id
                            ? "loading-disabled"
                            : ""
                        }`}
                      >
                        <div className="lockers">
                          <span className="dot">{8}</span>
                          {getLocker[7].status === "available" ? (
                            <>
                              {selectedLocker === getLocker[7]._id && (
                                <div className="locker-button-text">OPEN</div>
                              )}
                              <img
                                src={yeslocker}
                                alt="yes"
                                onClick={() =>
                                  displayOpen(getLocker[7]._id, "8")
                                }
                              />
                            </>
                          ) : (
                            <>
                              {selectedLocker === getLocker[7]._id && (
                                <div className="locker-button-text">CLOSE</div>
                              )}
                              <img
                                src={nolocker}
                                onClick={() =>
                                  displayOpen1(getLocker[7]._id, "8")
                                }
                                alt="yes"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* <div className=" row gap locker-row mt-3 overflow-auto  align-items-end">
                  {getLocker[0] && (
                    <>
                      <div className="col-1"></div>
                      <div
                        className={`col-2  ${
                          isLoading && selectedLocker !== getLocker[0]._id
                            ? "loading-disabled"
                            : ""
                        }`}
                      >
                        <div className="lockers">
                          <span className="dot1">{1}</span>
                          {getLocker[0].status === "available" ? (
                            <>
                              {selectedLocker === getLocker[0]._id && (
                                <div className="locker-button-text">OPEN</div>
                              )}
                              <img
                                src={shortyes}
                                alt="yes"
                                onClick={() =>
                                  displayOpen(
                                    getLocker[0]._id,
                                    getLocker[0].relay
                                  )
                                }
                              />
                            </>
                          ) : (
                            <>
                              {selectedLocker === getLocker[0]._id && (
                                <div className="locker-button-text">CLOSE</div>
                              )}
                              <img
                                src={shortno}
                                onClick={() =>
                                  displayOpen1(
                                    getLocker[0]._id,
                                    getLocker[0].relay
                                  )
                                }
                                alt="yes"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {getLocker[3] && (
                    <div
                      className={`col-2  ${
                        isLoading && selectedLocker !== getLocker[3]._id
                          ? "loading-disabled"
                          : ""
                      }`}
                    >
                      <div className="lockers"></div>
                    </div>
                  )}
                </div> */}

              {/* <div className="row gap locker-row mt-3 overflow-auto d-flex align-items-end">
                  {getLocker[0] && (
                    <>
                      <div className="col-1"></div>
                      <div
                        className={`col-2  ${
                          isLoading && selectedLocker !== getLocker[0]._id
                            ? "loading-disabled"
                            : ""
                        }`}
                      >
                        <div className="lockers">
                          <span className="dot1">{1}</span>
                          {getLocker[0].status === "available" ? (
                            <>
                              {selectedLocker === getLocker[0]._id && (
                                <div className="locker-button-text">OPEN</div>
                              )}
                              <img
                                src={shortyes}
                                alt="yes"
                                onClick={() =>
                                  displayOpen(
                                    getLocker[0]._id,
                                    getLocker[0].relay
                                  )
                                }
                              />
                            </>
                          ) : (
                            <>
                              {selectedLocker === getLocker[0]._id && (
                                <div className="locker-button-text">CLOSE</div>
                              )}
                              <img
                                src={shortno}
                                onClick={() =>
                                  displayOpen1(
                                    getLocker[0]._id,
                                    getLocker[0].relay
                                  )
                                }
                                alt="yes"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {getLocker[3] && (
                    <div
                      className={`col-2  ${
                        isLoading && selectedLocker !== getLocker[3]._id
                          ? "loading-disabled"
                          : ""
                      }`}
                    >
                      <div className="lockers"></div>
                    </div>
                  )}
                </div> */}

              {/* <div className="row locker-row mt-3 d-flex align-items-end">
                  {getLocker[1] && (
                    <>
                      <div className="col-1 "></div>
                      <div
                        className={`col-2  ${
                          isLoading && selectedLocker !== getLocker[1]._id
                            ? "loading-disabled"
                            : ""
                        }`}
                      >
                        <div className="lockers">
                          <span className="dot1">{2}</span>
                          {getLocker[1].status === "available" ? (
                            <>
                              {selectedLocker === getLocker[1]._id && (
                                <div className="locker-button-text">OPEN</div>
                              )}
                              <img
                                src={shortyes}
                                alt="yes"
                                onClick={() =>
                                  displayOpen(
                                    getLocker[1]._id,
                                    getLocker[1].relay
                                  )
                                }
                              />
                            </>
                          ) : (
                            <>
                              {selectedLocker === getLocker[1]._id && (
                                <div className="locker-button-text">CLOSE</div>
                              )}
                              <img
                                src={shortno}
                                onClick={() =>
                                  displayOpen1(
                                    getLocker[1]._id,
                                    getLocker[1].relay
                                  )
                                }
                                alt="yes"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {getLocker[4] && (
                    <div
                      className={`col-2  ${
                        isLoading && selectedLocker !== getLocker[4]._id
                          ? "loading-disabled"
                          : ""
                      }`}
                    >
                      <div className="lockers">
                        <span style={{ left: 120, top: 30 }} className="dot">
                          {4}
                        </span>
                        {getLocker[4].status === "available" ? (
                          <>
                            {selectedLocker === getLocker[4]._id && (
                              <div className="locker-button-text">OPEN</div>
                            )}
                            <img
                              src={shortyes}
                              height={210}
                              alt="yes"
                              onClick={() =>
                                displayOpen(
                                  getLocker[4]._id,
                                  getLocker[4].relay
                                )
                              }
                            />
                          </>
                        ) : (
                          <>
                            {selectedLocker === getLocker[4]._id && (
                              <div className="locker-button-text">CLOSE</div>
                            )}
                            <img
                              src={nolocker}
                              onClick={() =>
                                displayOpen1(
                                  getLocker[4]._id,
                                  getLocker[4].relay
                                )
                              }
                              alt="yes"
                            />
                          </>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="col-2 ">
                    <div className="lockers">
                      <img src={mockup} alt="yes" width={180} height={200} />
                    </div>
                  </div>
                </div> */}

              {/* <div className="row locker-row mt-3 d-flex align-items-end">
                  {getLocker[2] && (
                    <>
                      <div className="col-1 "></div>
                      <div
                        className={`col-2  ${
                          isLoading && selectedLocker !== getLocker[2]._id
                            ? "loading-disabled"
                            : ""
                        }`}
                      >
                        <div className="lockers">
                          <span className="dot1">{3}</span>
                          {getLocker[2].status === "available" ? (
                            <>
                              {selectedLocker === getLocker[2]._id && (
                                <div className="locker-button-text">OPEN</div>
                              )}
                              <img
                                src={shortyes}
                                alt="yes"
                                onClick={() =>
                                  displayOpen(
                                    getLocker[2]._id,
                                    getLocker[2].relay
                                  )
                                }
                              />
                            </>
                          ) : (
                            <>
                              {selectedLocker === getLocker[2]._id && (
                                <div className="locker-button-text">CLOSE</div>
                              )}
                              <img
                                src={shortno}
                                onClick={() =>
                                  displayOpen1(
                                    getLocker[2]._id,
                                    getLocker[2].relay
                                  )
                                }
                                alt="yes"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {getLocker[5] && (
                    <div
                      className={`col-2  ${
                        isLoading && selectedLocker !== getLocker[5]._id
                          ? "loading-disabled"
                          : ""
                      }`}
                    >
                      <div className="lockers">
                        <span style={{ left: 120, top: 30 }} className="dot">
                          {5}
                        </span>
                        {getLocker[5].status === "available" ? (
                          <>
                            {selectedLocker === getLocker[5]._id && (
                              <div className="locker-button-text">OPEN</div>
                            )}
                            <img
                              src={shortyes}
                              height={210}
                              alt="yes"
                              onClick={() =>
                                displayOpen(
                                  getLocker[5]._id,
                                  getLocker[5].relay
                                )
                              }
                            />
                          </>
                        ) : (
                          <>
                            {selectedLocker === getLocker[5]._id && (
                              <div className="locker-button-text">CLOSE</div>
                            )}
                            <img
                              src={shortno}
                              height={210}
                              onClick={() =>
                                displayOpen1(
                                  getLocker[5]._id,
                                  getLocker[5].relay
                                )
                              }
                              alt="yes"
                            />
                          </>
                        )}
                      </div>
                    </div>
                  )}
                  {getLocker[5] && (
                    <div
                      className={`col-2  ${
                        isLoading && selectedLocker !== getLocker[5]._id
                          ? "loading-disabled"
                          : ""
                      }`}
                    >
                      <div className="lockers">
                        <span style={{ left: 120, top: 30 }} className="dot">
                          {6}
                        </span>
                        {getLocker[5].status === "available" ? (
                          <>
                            {selectedLocker === getLocker[5]._id && (
                              <div className="locker-button-text">OPEN</div>
                            )}
                            <img
                              src={shortyes}
                              height={210}
                              alt="yes"
                              onClick={() =>
                                displayOpen(
                                  getLocker[5]._id,
                                  getLocker[5].relay
                                )
                              }
                            />
                          </>
                        ) : (
                          <>
                            {selectedLocker === getLocker[5]._id && (
                              <div className="locker-button-text">CLOSE</div>
                            )}
                            <img
                              src={shortno}
                              height={210}
                              onClick={() =>
                                displayOpen1(
                                  getLocker[5]._id,
                                  getLocker[5].relay
                                )
                              }
                              alt="yes"
                            />
                          </>
                        )}
                      </div>
                    </div>
                  )}
                  {getLocker[5] && (
                    <div
                      className={`col-2  ${
                        isLoading && selectedLocker !== getLocker[5]._id
                          ? "loading-disabled"
                          : ""
                      }`}
                    >
                      <div className="lockers">
                        <span style={{ top: 45, left: 80 }} className="dot">
                          {7}
                        </span>
                        {getLocker[5].status === "available" ? (
                          <>
                            {selectedLocker === getLocker[5]._id && (
                              <div className="locker-button-text">OPEN</div>
                            )}
                            <img
                              src={yeslocker}
                              width={150}
                              height={400}
                              alt="yes"
                              onClick={() =>
                                displayOpen(
                                  getLocker[5]._id,
                                  getLocker[5].relay
                                )
                              }
                            />
                          </>
                        ) : (
                          <>
                            {selectedLocker === getLocker[5]._id && (
                              <div className="locker-button-text">CLOSE</div>
                            )}
                            <img
                              src={nolocker}
                              width={150}
                              height={400}
                              onClick={() =>
                                displayOpen1(
                                  getLocker[5]._id,
                                  getLocker[5].relay
                                )
                              }
                              alt="yes"
                            />
                          </>
                        )}
                      </div>
                    </div>
                  )}
                  {getLocker[5] && (
                    <div
                      className={`col-2  ${
                        isLoading && selectedLocker !== getLocker[5]._id
                          ? "loading-disabled"
                          : ""
                      }`}
                    >
                      <div className="lockers">
                        <span style={{ top: 48, left: 105 }} className="dot">
                          {8}
                        </span>
                        {getLocker[5].status === "available" ? (
                          <>
                            {selectedLocker === getLocker[5]._id && (
                              <div className="locker-button-text">OPEN</div>
                            )}
                            <img
                              src={yeslocker}
                              width={200}
                              height={400}
                              alt="yes"
                              onClick={() =>
                                displayOpen(
                                  getLocker[5]._id,
                                  getLocker[5].relay
                                )
                              }
                            />
                          </>
                        ) : (
                          <>
                            {selectedLocker === getLocker[5]._id && (
                              <div className="locker-button-text">CLOSE</div>
                            )}
                            <img
                              src={nolocker}
                              width={200}
                              height={400}
                              onClick={() =>
                                displayOpen1(
                                  getLocker[5]._id,
                                  getLocker[5].relay
                                )
                              }
                              alt="yes"
                            />
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </div> */}
            </div>
          </div>
          <Modal
            isOpen={isModalOpen}
            onRequestClose={closeModal}
            contentLabel="Example Modal"
            className="modal-content-update"
            style={{
              overlay: {
                backgroundColor: "rgb(43 41 41 / 75%)", // Update the background color here
              },
              content: {
                backgroundColor: "white", // Update the modal content background color here
              },
            }}
            shouldCloseOnOverlayClick={false}
          >
            <img src={lock} alt="lock" className="modal-image" />
            <p className="modal-text mt-3">
              Do you want to release this locker?
            </p>
            <div className="d-flex gap-sm-3 gap-lg-3 ">
              <button className="modal-btn1" onClick={returnLocker}>
                Yes
              </button>
              <button className="modal-btn2" onClick={closeModal}>
                No
              </button>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default DashboardScr;
